export default "__VITE_ASSET__RxJN5SAu__"